import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 367.71 367.71' fill={fillColor} className={className}>
      <path d='M216,146.74c0,.36.11.71.11,1.07a18.92,18.92,0,1,1-30.78-14.63c-1.08-.07-2.15-.17-3.25-.17A49,49,0,1,0,216,146.74Z' />
      <path d='M64.35,197.71H88.69a15.79,15.79,0,0,0,0-31.58H64.36A118.75,118.75,0,0,1,166.27,64.22V88.69a15.79,15.79,0,1,0,31.58,0V15.79a15.79,15.79,0,1,0-31.58,0v18A149,149,0,0,0,33.91,166.13H15.79a15.79,15.79,0,0,0,0,31.58H34a149,149,0,0,0,116.45,129.8L163,299.24A118.85,118.85,0,0,1,64.35,197.71Z' />
      <path d='M351.92,166.13H330.13A149,149,0,0,0,211.53,35.86L199,64.27A118.83,118.83,0,0,1,299.76,166.13H279a15.79,15.79,0,0,0,0,31.58h20.75A118.76,118.76,0,0,1,197.85,299.62V279a15.79,15.79,0,0,0-31.58,0v72.91a15.79,15.79,0,0,0,31.58,0V330.07A149,149,0,0,0,330.2,197.71h21.72a15.79,15.79,0,0,0,0-31.58Z' />
    </svg>
  );
});

export default React.memo(Icon);
